import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'
import Api from './../../../services/api'
import User from './../../../services/auth'

export default {
  name: 'project',
  props: [],
  components: {
    Header,
  },
  data() {
    return {
      email: '',
      password: '',
      password_confirm: '',
      validationMessage: '',
      vForgot: true,
      vReset: false,
      successSent: false,
      success: '',
      failSent: false,
      errorSent: '',
      vLogin: false,
    }
  },
  methods: {
    onAutoFill(me, callback) {
      var last = $(me).val()
      var infunc = function() {
        var text = $(me).val()
        if (text != last) {
          last = text
          callback(me)
          return
        }
        setTimeout(infunc, 100)
      }
      setTimeout(infunc, 100)
    },
    resetPassword() {
      console.log('reset password >>>>>>>>>>>>>>>>>>>>>>')
      console.log(this.email)
      this.vForgot = true
      var userEmail = this.email
      this.$http
        .post('/forgot', {
          email: userEmail,
        })
        .then(
          response => {
            console.log('Reset password email ' + this.email)
            console.log(response)
            if (response.body == 'ok') {
              this.failSent = false
              this.successSent = true
              this.success =
                'An email was sent to the email address to reset your password.'
            } else {
              this.successSent = false
              this.failSent = true
              this.errorSent = 'User error. ' + response.body.error
            }
          },
          error => {
            this.validationMessage = 'User error. ' + error + '.'
          }
        )
    },
    updatePassword() {
      this.$http
        .post('/reset', {
          password: this.password,
          token: this.$route.params.token,
        })
        .then(
          response => {
            console.log('fghghgfhghfg' + this.email)
            console.log(response)
            this.vReset = false
            this.successSent = true
            this.success = 'Password successfully updated'
            this.vLogin = true
            window.location.href = '/signin'
          },
          error => {
            this.validationMessage = 'User error. ' + error
          }
        )
    },
    SignIn() {
      window.location.href = '/signin'
    },
  },
  created() {
    if (
      this.$route.path.indexOf('reset_password') > -1 &&
      this.$route.params.id != ''
    ) {
      this.vForgot = false
      this.vReset = true
      console.log(this.$route.params)
    }
  },
  mounted: function() {
    window.addEventListener('resize', this.handleResize)

    this.onAutoFill(
      'input[type="email"]:-webkit-autofill,input[type="password"]:-webkit-autofill',
      function(input) {
        $(input)
          .siblings('label')
          .addClass('active')
      }
    )
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Account/ResetPassword/ResetPassword.component.js